import { Component, OnInit, Input } from '@angular/core';
import { JobService } from 'src/app/services/job.service';
import { SpinnerService } from 'src/app/services/spinner.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent implements OnInit {

  constructor(private jobService: JobService, private spinner: SpinnerService) { }

  list: any[];
  criteria: any = {};
  @Input() type;
  data: any;

  async ngOnInit() {
    this.criteria.Type = this.type;
    await this.load();
  }

  add() { this.data = Object.assign({ Type: this.type, Subtype: '', Data: {} }); }
  async load() {
    this.spinner.show();
    this.list = await this.jobService.getIndexData(this.criteria);
    delete this.data;
    this.spinner.hide();
  }
  async save() {
    await this.jobService.setIndexData(this.data);
    await this.load();
  }
  async remove(item) {
    item.Subtype = 'REMOVED';
    await this.jobService.setIndexData(item);
    await this.load();
  }
}
